import React from "react";

import { Trans } from "react-i18next";
import i18next from "i18next";
import i18n from "../../../i18n";

import {
  Classes,
  Tag,
  Dialog,
  Button,
  Callout,
  Icon
} from "@blueprintjs/core";

import {
  authenticatedGetFetch,
  authenticatedPutFetch
} from "../../../utils/AuthenticatedFetch";

import { mefMontantStr, mefDate, mefPlate, userIcons } from "../../../utils/mef";

export class CCManagement extends React.Component {
  constructor() {
    super();
    this.state = {
      requestWait: false,
    };
  }

  componentDidMount() {
    authenticatedGetFetch("/cc/" + this.props.id + "?srv=" + this.props.server,
      (response) => this.setState({ ...response })
    );
  }

  CCAction(props) {
    return <Button icon={props.icon} text={props.text}
      onClick={() => {
        authenticatedPutFetch(
          "/cc/" + props.id + "?srv=" + props.server,
          props.action,
          () => {
            props.self.setState(
              { requestWait: true },
              () =>
                setTimeout(
                  () =>
                    authenticatedGetFetch(
                      "/cc/" + props.id + "?srv=" + props.server,
                      (response) => {
                        props.self.setState({
                          ...response,
                          requestWait: false,
                        });
                      }
                    ),
                  1000
                ) // PGEQ can take time to update the table
            );
          }
        );
      }
    } />;
  }

  render() {
    const events = [];
    if (this.state.events !== undefined) {
      for (const event of this.state.events) {
        events.push(
          <li key={event.DAYEVEN}>
            {new Date(event.DAYEVEN).toLocaleString(i18next.language)} :{" "}
            <b>
              {(event.event !== undefined && event.event !== null) && <Tag intent={event.event.intent}><Trans>{"event" + event.event.id}</Trans></Tag>}
            </b>{" "}
            <Trans>on device</Trans> {this.props.deviceLookup[event.syncServerId + "_" + event.NUMEEQUI]}{" "}
            {event.MONTSTAT !== undefined && event.MONTSTAT > 0 ? (
              <span>({mefMontantStr(event.MONTSTAT)})</span>
            ) : null}
          </li>
        );
      }
    }

    const actions = [];
    if (this.state.PRESENT === "T")
      actions.push(<this.CCAction key="ral" id={this.props.id} action={{ present: false }} icon="follower" text={i18n.t("set absent")} server={this.props.server} self={this}/>);
    /* else // should be possible ??
      actions.push(<this.CCAction key="sal" id={this.props.id} action={{ present: true }} icon="blocked-person" text={i18n.t("set present")} />); */

    return (
      <Dialog
        title={<span><Trans>userType1</Trans> <b>n°{this.props.id}</b></span>}
        isOpen={this.props.id !== undefined}
        canEscapeKeyCancel={true}
        canOutsideClickCancel={true}
        intent="primary"
        icon={userIcons[1]}
        onClose={() => {
          if (this.props.onClose !== undefined) this.props.onClose();
        }}
        onCancel={() => {
          if (this.props.onClose !== undefined) this.props.onClose();
        }}
      >
        {/* unused fields:
          "NUMEROCB": "CF3D53467",
          "TOKEN": "************8796=2310***************",
          "DATLMS": "20220426165318",
          "TOKEN2": "0000000001573428"
      */}
        {this.state.PRESENT === undefined ? (
          <Callout key={"img"} intent="warning" title={<span><Trans>userType1</Trans> <Trans>not found on the server</Trans></span>}>
            <p><Trans>can't retreive data</Trans></p>
            <p><Trans>the ticket could be purged according to the server settings</Trans></p>
            <div className="flexbox-center"><Icon icon="unknown-vehicle" size="100" /></div>
          </Callout>
        ) : (
          <div>
            <ul>
              <li><Trans>parking state:</Trans>{this.state.PRESENT === "T" ? <Tag intent="success"><Trans>present</Trans></Tag> : <Tag intent="warning"><Trans>finished</Trans></Tag>}</li>
              <li><Trans>park:</Trans>{this.props.parkLookup[this.state.NUMEPARC]}</li>
              <li><Trans>entry device:</Trans>{this.props.deviceLookup[this.props.server + "_" + this.state.EQUIENTR]}</li>
              <li><Trans>entry date:</Trans>{mefDate(this.state.DATEENTR)}</li>
              <li>{i18n.t("paid amount") + i18n.t(":")}{mefMontantStr(this.state.MTPAYE)}</li>
              <li><Trans>credit card type:</Trans><Trans>{"ccType" + this.state.TYPECART}</Trans></li>
              {this.state.IMMAT && <li><Trans>associated license plate:</Trans><Tag icon="blank" className="licenseplate-little">{mefPlate(this.state.IMMAT)}</Tag></li>}
              <li><Trans>event history</Trans> :</li>
              <ul>{events}</ul>
            </ul>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              {actions}
            </div>
          </div>
        )}
      </Dialog>
    );
  }
}
